export default __webpack_public_path__ + "static/media/Hiking-at-Sierra-Madre.82c81dd9.jpeg";